import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error details
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-orange-50 flex items-center justify-center">
          <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-2xl mx-4">
            <div className="text-red-500 text-6xl mb-4">💥</div>
            <h2 className="text-xl font-bold text-gray-800 mb-4">Runtime Error Caught</h2>
            
            <div className="text-left bg-gray-100 p-4 rounded-lg mb-4">
              <h3 className="font-bold text-red-600 mb-2">Error:</h3>
              <pre className="text-sm text-red-700 whitespace-pre-wrap">
                {this.state.error && this.state.error.toString()}
              </pre>
              
              {this.state.errorInfo && (
                <>
                  <h3 className="font-bold text-red-600 mt-4 mb-2">Component Stack:</h3>
                  <pre className="text-sm text-red-700 whitespace-pre-wrap">
                    {this.state.errorInfo.componentStack}
                  </pre>
                </>
              )}
            </div>
            
            <div className="flex gap-4 justify-center">
              <button 
                onClick={() => window.location.reload()} 
                className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600"
              >
                Reload App
              </button>
              <button 
                onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })} 
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
